import { useDispatch } from 'react-redux';
import { setModal, setSelectedProduct } from '../../../../Features/inventoryManagementSlice';

function ProductBar({ product }) {
    const dispatch = useDispatch();

    const handleEditStock = () => {
        dispatch(setSelectedProduct(product));
        dispatch(setModal('edit-product-stock'));
    }

    return (
        <div className='flex items-center border-t border-[#EAEAEA]'>
            <div className="w-[58%] px-[10px] py-[6px] flex items-center gap-2">
                {
                    product?.VarientImgUrl?.length > 0 ? (
                        <div className="size-16 rounded-lg overflow-hidden">
                            <img
                                className="size-full object-cover"
                                src={product?.VarientImgUrl[0]}
                                alt={product.VarientName}
                            />
                        </div>
                    ) : (
                        <div className="size-16 rounded-lg bg-[#EAEAEA]"></div>
                    )
                }

                <div className="flex flex-col gap-1 w-[calc(100%-64px-8px)]">
                    <h1 className='text-[14px] leading-6 font-semibold text-[#121212] w-full whitespace-nowrap overflow-hidden text-ellipsis'>{product.VarientName}</h1>

                    <div className='flex items-center gap-1 font-medium text-[12px] leading-6 text-[#666666]'>
                        <span>{product.category === 'Beauty & Personal Care' ? 'Volume' : 'Size'}: {product.VarientSize}</span>

                        <span>Color: {product.VarientColor}</span>
                    </div>
                </div>
            </div>

            <h2 className="w-[13%] px-[10px] py-[26px] text-[14px] leading-6 text-[#121212] text-nowrap overflow-hidden text-ellipsis">{product.sku || '-'}</h2>

            <h2 className="w-[13%] px-[10px] py-[26px] text-[14px] leading-6 text-[#121212]">{product.VarientQuantity}</h2>

            <div className="w-[16%] px-[10px] py-5">
                <button onClick={handleEditStock} className='outline-none border border-[#757575] bg-[#FFFFFF] px-3 py-[6px] rounded text-[12px] leading-6 font-semibold text-[#121212]'>Edit Stocks</button>
            </div>
        </div>
    );
}

export default ProductBar;
